// @vendor
import React from 'react';
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @actions
const hireWelcomeAccountActions = require('actions/hireWelcomeAccount/hireWelcomeAccount');
const blockedAccountsAction = require('actions/blockedAccounts');
const contractsActions = require('actions/contracts');
const preContractualMailActions = require('actions/preContractualMailInfo');
const profile = require('actions/profile');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');

// @components
import HireWelcomeAccountComponent from 'components/hireWelcomeAccount/HireWelcomeAccountComponent.js';

// @helpers
const { formatText } = require('core/i18n').i18n;

// @constants
const {
    HIRE_WELCOME_PAYROLL_ACCOUNT_CODE
} = require('constants/operationCodesAccounts');
const {
    WELCOME_ACCOUNT_PAYROLL_STANDARD,
    WELCOME_ACCOUNT_PAYROLL_SUBTYPE,
    WELCOME_ACCOUNT_PAYROLL_TYPE,
} = require('constants/index');

class HireWelcomePayrollAccountView extends React.Component {

    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            getBlockedAccounts,
            immAccounts
        } = this.props;

        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_WELCOME_PAYROLL_ACCOUNT_CODE);
    }

    componentWillUnmount() {
        const {
            resetBlockedAccounts,
            resetHireWelcome,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props;

        resetBlockedAccounts();
        resetHireWelcome();
        resetPrecontractualMail();
        resetTermsAndCondsText();
    }

    handleCancel = () => {
        this.props.history.push('/myprofile/accounts');
    }

    handleFinish = () => {
        const { finishWelcomeAccount } = this.props;

        finishWelcomeAccount({
            isPayroll: true,
            standard: WELCOME_ACCOUNT_PAYROLL_STANDARD,
            subType: WELCOME_ACCOUNT_PAYROLL_SUBTYPE,
            type: WELCOME_ACCOUNT_PAYROLL_TYPE,
        });
    }

    render() {
        const {
            addIntervener,
            flagBasedFeatures,
            getContractInformation,
            immAccounts,
            immGlobalVariables,
            immHireWelcomeAccount,
            immProfileFields,
            onCheckboxChange,
            preContractualMail,
            removeIntervener,
            requestInterveners,
            requestProfile,
            restoreDefaultInterveners,
            sendPreContractualMail,
            setIntervenerType,
            setSelectedAccountValue,
            setTermsAndCondsText,
            setVisibleStep,
            setWillCancel,
            validateStep
        } = this.props;

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };
        const breadcrumbTitle = formatText('hireWelcomeAccount-hireWelcomeAccount_welcomeAccountPayrollBreadcrumbTitle');
        const welcomeAccountTitle = formatText('hireWelcomeAccount-hireWelcomeAccount_welcomeAccountPayrollTitle');
        const confirmationSubtitle = 'hireWelcomeAccount-hireWelcomeAccountPayroll_step3Subtitle';
        const confirmationTitle = 'hireWelcomeAccount-hireWelcomeAccountPayroll_step3Title';

        return (
            <HireWelcomeAccountComponent
                actions={actions}
                addIntervener={addIntervener}
                breadcrumbTitle={breadcrumbTitle}
                confirmationSubtitle={confirmationSubtitle}
                confirmationTitle={confirmationTitle}
                flagBasedFeatures={flagBasedFeatures}
                getContractInformation={getContractInformation}
                immAccounts={immAccounts}
                immGlobalVariables={immGlobalVariables}
                immHireWelcomeAccount={immHireWelcomeAccount}
                immProfileFields={immProfileFields}
                onCheckboxChange={onCheckboxChange}
                operativeName={'welcomePayrollAccount'}
                preContractualMail={preContractualMail}
                productName={breadcrumbTitle}
                removeIntervener={removeIntervener}
                requestInterveners={requestInterveners}
                requestProfile={requestProfile}
                restoreDefaultInterveners={restoreDefaultInterveners}
                sendPreContractualMail={sendPreContractualMail}
                setIntervenerType={setIntervenerType}
                setSelectedAccountValue={setSelectedAccountValue}
                setTermsAndCondsText={setTermsAndCondsText}
                standar={WELCOME_ACCOUNT_PAYROLL_STANDARD}
                subtype={WELCOME_ACCOUNT_PAYROLL_SUBTYPE}
                title={welcomeAccountTitle}
                type={WELCOME_ACCOUNT_PAYROLL_TYPE}
                welcomeAccountPayroll
            />
        )
    }
}

HireWelcomePayrollAccountView.propTypes = {
    addIntervener: PropTypes.func.isRequired,
    finishWelcomeAccount: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    getBlockedAccounts: PropTypes.func,
    getContractInformation: contractsActions.getContractInformation,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireWelcomeAccount: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    onCheckboxChange: PropTypes.object.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    removeIntervener: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func,
    requestProfile: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    resetHireWelcome: PropTypes.func,
    resetPrecontractualMail: PropTypes.func,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    restoreDefaultInterveners: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setIntervenerType: PropTypes.func.isRequired,
    setSelectedAccountValue: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
}

module.exports = HireWelcomePayrollAccountView;
module.exports.HireWelcomePayrollAccountView = connect (
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immAccounts: state.accounts,
        immGlobalVariables: state.globalVariables,
        immHireWelcomeAccount: state.hireWelcomeAccount,
        immProfileFields: state.profile,
        preContractualMail: state.preContractualMail,
    }), {
        addIntervener: hireWelcomeAccountActions.addIntervener,
        finishWelcomeAccount: hireWelcomeAccountActions.finishWelcomeAccount,
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        getContractInformation: contractsActions.getContractInformation,
        onCheckboxChange: hireWelcomeAccountActions.onCheckboxChange,
        removeIntervener: hireWelcomeAccountActions.removeIntervener,
        requestInterveners: hireWelcomeAccountActions.requestInterveners,
        requestProfile: profile.requestProfile,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        resetHireWelcome: hireWelcomeAccountActions.resetHireWelcome,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        restoreDefaultInterveners: hireWelcomeAccountActions.restoreDefaultInterveners,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
        setIntervenerType: hireWelcomeAccountActions.setIntervenerType,
        setSelectedAccountValue: hireWelcomeAccountActions.setSelectedAccountValue,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hireWelcomeAccountActions.setVisibleStep,
        setWillCancel: hireWelcomeAccountActions.setWillCancel,
        validateStep: hireWelcomeAccountActions.validateStep
    }
)(withRouter(HireWelcomePayrollAccountView));
